import { Card, Button, Spin, Typography, Row, Col } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import CreateCreditCardModal from '../../component/customer/CreateCreditCardModal';
import CreditCardList from '../../component/customer/CreditCardList';
import CustomerInfo from '../../component/customer/CustomerInfo';
import { CreditCardResponse2 } from '../../model/Credit-card.model';
import CustomerResponse from '../../model/Customer.model';
import { PaymentResponse } from '../../model/Payment.model';
import CreditCardService from '../../service/credit-card-service/Credit-card.service';
import CustomerService from '../../service/customer-service/Customer.service';

import { Select, DatePicker, Badge } from 'antd';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import useRole from '../../hook/useRole';
import useEmployee from '../../hook/useEmployee';

const { MonthPicker } = DatePicker;
const { Title } = Typography;

const CustomerDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const highlightPaymentId = queryParams.get('highlightPayment');
  const monthParam = queryParams.get('month');
  const yearParam = queryParams.get('year');
  const [customer, setCustomer] = useState<CustomerResponse | null>(null);
  const [creditCards, setCreditCards] = useState<CreditCardResponse2[]>([]);
  const [payments, setPayments] = useState<PaymentResponse[]>([]);
  const [filteredPayments, setFilteredPayments] = useState<PaymentResponse[]>(
    []
  );
  const [selectedMonth, setSelectedMonth] = useState<string | null>(
    monthParam && yearParam
      ? `${yearParam}-${monthParam.padStart(2, '0')}`
      : null
  );
  const [selectedStatus, setSelectedStatus] = useState<string>('all');
  const [loading, setLoading] = useState(true);
  const role = useRole();
  const { employee } = useEmployee();

  const fetchCustomerDetail = async () => {
    if (!id) return;
    try {
      const [customerData, cardsData] = await Promise.all([
        CustomerService.getCustomerById(Number(id)),
        CreditCardService.getCardsByCustomerId(Number(id)),
        // PaymentService.getPaymentsByCustomerId(Number(id)),
      ]);
      setCustomer(customerData);
      setCreditCards(cardsData);
      // setPayments(paymentsData);

      // Debug log
      console.log('Customer data:', customerData);
      console.log('Employee data:', employee);
      console.log('Role:', role);
    } catch (error) {
      console.error('Error fetching customer details:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomerDetail();
  }, [id]);

  useEffect(() => {
    filterPayments();
  }, [payments, selectedMonth, selectedStatus]);

  useEffect(() => {
    const handleMonthChange = () => {
      // Remove the auto update of the month - no default value needed
    };
    const intervalId = setInterval(handleMonthChange, 1000 * 60 * 60 * 24);
    return () => clearInterval(intervalId);
  }, []);

  const filterPayments = () => {
    let filtered = payments;
    if (selectedMonth) {
      filtered = filtered.filter((payment) =>
        payment.paymentDate.startsWith(selectedMonth)
      );
    }
    if (selectedStatus !== 'all') {
      filtered = filtered.filter(
        (payment) => payment.status === selectedStatus
      );
    }
    setFilteredPayments(filtered);
  };

  const handleMonthChange = (
    date: Dayjs | null,
    dateString: string | string[]
  ) => {
    if (Array.isArray(dateString)) return;
    if (date) {
      const monthYear = date.format('YYYY-MM');
      setSelectedMonth(monthYear);
    } else {
      setSelectedMonth(null);
    }
  };

  const handleStatusChange = (value: string) => {
    setSelectedStatus(value);
  };

  const getMonthCellRender = (date: Dayjs) => {
    const monthYear = date.format('YYYY-MM');
    const hasIncompletePayments = payments.some(
      (payment) =>
        payment.paymentDate.startsWith(monthYear) &&
        payment.status !== 'COMPLETED'
    );
    return (
      <div className="ant-picker-cell-inner" style={{ position: 'relative' }}>
        <span>{date.format('MMM')}</span>
        {hasIncompletePayments && (
          <Badge status="error" style={{ position: 'absolute', right: 0 }} />
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  if (!customer) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Typography.Text>Không tìm thấy khách hàng</Typography.Text>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6">
      <div className="mb-4 md:mb-6">
        <Button
          onClick={() => navigate(-1)}
          type="default"
          icon={<ArrowLeftOutlined />}
          className="flex items-center gap-2"
        >
          Quay lại
        </Button>
      </div>

      <div className="grid grid-cols-1 gap-4 md:gap-6">
        <Card className="shadow-sm">
          <Title level={4} className="mb-4">
            Thông tin khách hàng
          </Title>
          <CustomerInfo customer={customer} />
        </Card>

        <Card className="shadow-sm">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
            <Title level={4} className="mb-0">
              Thông tin thẻ
            </Title>

            {/* Cho phép tất cả nhân viên và admin tạo thẻ mới */}
            <CreateCreditCardModal
              customerId={Number(id)}
              onSuccess={fetchCustomerDetail}
            />
          </div>
          <CreditCardList
            creditCards={creditCards}
            onRefresh={fetchCustomerDetail}
            customerId={Number(id)}
          />
        </Card>
      </div>
    </div>
  );
};

export default CustomerDetail;
